module.exports = __webpack_public_path__ + "img/bj.47e864f3.png";